<template>
  <div>
    <member-entry-form
      :method="method"
      :action="action"
      :post-params="postParams"
      :input-param="inputParam"
      :items-id="itemsId"
      :itemScheduleId="itemScheduleId"
      :categoryId="categoryId"
      :guestId="guestId"
      :entry-detail-required="entryDetailRequired"
      :is-rand-select="isRandSelect"
      :exp-text="expText"
      :order-genre="orderGenre"
      :input-entry-type="inputEntryType"
      :is-uragei="isUragei"
    ></member-entry-form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import GuestEntryForm from './GuestEntryForm';
import MemberEntryForm from './MemberEntryForm';
import NonMemberEntryForm from './NonMemberEntryForm';
import dataControl from './mixins/dataControl';
import formControl from './mixins/formControl';

export default {
  mixins: [dataControl, formControl],
  props: {
    isUragei: {
      type: Number,
      default: 0
    },
    isTextContents: {
        type: Boolean,
        default: false
    },
    isNonMember: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    isValidToken: false
  }),
  // 別ブラウザでログインした際に<GuestEntryForm>を表示する
  beforeMount() {
    this.isValidToken = this.isLoggedIn;
  },
  watch: {
    isLoggedIn() {
      if (!this.isLoggedIn) {
        this.isValidToken = false;
      }else{
        this.isValidToken = true
      }
    }
  },
  computed: {
    nonmemberAction() {
      return this.isNonMember ? `${this.action}?nonmember=1` : this.action
    },
    ...mapGetters(['isLoggedIn'])
  },
  components: {
    NonMemberEntryForm,
    GuestEntryForm,
    MemberEntryForm
  }
};
</script>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/EntryForm/EntryFormLineDaily.vue